import React, {useState, useContext, useRef, useEffect} from 'react';
import { IonContent, IonText, IonHeader, IonImg, IonTitle, IonToolbar, IonItem, IonList, IonMenuButton, IonButton, IonButtons, IonInput, IonModal, IonGrid, IonRow, IonCol, IonDatetime, IonFooter } from '@ionic/react';
import { IonSlides, IonSlide, IonLabel } from '@ionic/react';

import { Auth_MerchantID_context } from '../../../../storeState/auth_merchantID_context';


import '../../../../css/qavaApp.css';
import '../../../zPublic/css/zPublic.css'

export function AddEstimateItemModal (props) {

    //alert('inside CreateEmployeeModal');
    //alert(props.openModal);

    let authenticatedMerchent_context = useContext(Auth_MerchantID_context);

    const [acctID, setAcctID] = useState(authenticatedMerchent_context.acctID);
    const [schema, setSchemaName] = useState(authenticatedMerchent_context.schema);
    let [sessionID, setSessionID ] = useState(authenticatedMerchent_context.sessionID);
    let [baseURL, setBaseURL ] = useState(authenticatedMerchent_context.baseURL);


    let [itemName, setItemName] = useState(props.data.addition_type);
    let [itemDescription, setItemDescription] = useState(props.data.itemType);
    let [itemEstimatedPrice, setItemEstimatedPrice] = useState(props.data.itemDescription);

    let [row_1, setRow_1] = useState(false);
    let [row_2, setRow_2] = useState(false);
    let [row_3, setRow_3] = useState(false);
    let [row_4, setRow_4] = useState(false);
    let [row_5, setRow_5] = useState(false);




    function addItem_estimateToItem() 
    {
        const requestOptions = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            body: JSON.stringify({
                Tracker: '74101_add_estimateItem_to_scope',
                user: acctID,
                xConsultationID: props.data.consultationID,
                xScopeLineNumber: props.data.scopeLineNumber,
                xItemName: itemName,
                xItemDescription: itemDescription,
                xItemEstimatedPrice: itemEstimatedPrice,
                sessionID: sessionID,

            }),
        }

        
        fetch(baseURL+'proService_merchantAcct_argsjqApp', requestOptions)
        .then(res => res.text())
        .then(res => {

            alert(res);
        })
    }


    function closeModalHandler() {

        props.closeModal(false);
    }

    
    //alert("IN CREATE PRODUCT")

    return (
        <React.Fragment>
        {props.openModal == true ?
        (
        <IonModal isOpen={ props.openModal }>
             <IonContent className='bookedDetails_gridContent_multiple'>

            <IonSlides pager='true'>
                <IonSlide>
                    <IonGrid>
                        <IonRow> 
                            <IonCol>
                                <IonLabel>Item Name: </IonLabel>
                            </IonCol>
                            <IonCol>
                                {row_2 == true && <IonInput placeholder='Enter Estimate Name'  onIonChange={(e) => setItemName(e.detail.value)}></IonInput>}
                                {row_2 == false && <IonText>{itemName} </IonText>}
                            </IonCol>
                            {row_2 == false && <IonCol>
                                <IonButton onClick={() => setRow_2(true)}>Update</IonButton>
                            </IonCol>}
                            {row_2 == true && <IonCol>
                                <IonButton onClick={() => setRow_2(false)}>Confirm</IonButton>
                            </IonCol>}
                        </IonRow>
                        <IonRow>
                            <IonCol>
                                <IonLabel>Item Description: </IonLabel>
                            </IonCol>
                            <IonCol>
                                {row_3 == true && <IonInput placeholder='Enter Product Description' onIonChange={(e) => setItemDescription(e.detail.value)}></IonInput>}
                                {row_3 == false && <IonText>{itemDescription}</IonText>}
                            </IonCol>
                            {row_3 == false && <IonCol>
                                <IonButton onClick={() => setRow_3(true)}>Update</IonButton>
                            </IonCol>}
                            {row_3 == true && <IonCol>
                                <IonButton onClick={() => setRow_3(false)}>Confirm</IonButton>
                            </IonCol>}
                        </IonRow>
                        <IonRow>
                            <IonCol>
                                <IonLabel>Total Estimated Price: </IonLabel>
                            </IonCol>
                            <IonCol>
                                {row_4 == true && <IonInput placeholder='Enter Product Phone Number' onIonChange={(e) => setItemEstimatedPrice(e.detail.value)}></IonInput>}
                                {row_4 == false && <IonText>{itemEstimatedPrice}</IonText>}
                            </IonCol>
                            {row_4 == false && <IonCol>
                                <IonButton onClick={() => setRow_4(true)}>Update</IonButton>
                            </IonCol>}
                            {row_4 == true && <IonCol>
                                <IonButton onClick={() => setRow_4(false)}>Confirm</IonButton>
                            </IonCol>}
                        </IonRow>
                    </IonGrid>
                </IonSlide>
            </IonSlides>

        </IonContent>
        <IonFooter class='appFooter'>
                <IonGrid>
                    <IonRow>
                        <IonCol>
                            <IonButton onClick={() => addItem_estimateToItem()}> Confirm Estimate Item Creation </IonButton>
                        </IonCol>
                        <IonCol>
                            <IonButton onClick={() => closeModalHandler()}>Cancel </IonButton>
                        </IonCol>
                    </IonRow>
                </IonGrid>
        </IonFooter>
        </IonModal>
        ) : null}
        </React.Fragment>
        )
}